import { useState, useEffect } from "react";
import { SendAndArchiveOutlined } from "@mui/icons-material";
import { Box, Alert, AlertTitle, Button, Grid, Backdrop, CircularProgress } from "@mui/material";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { get_inscriptions, get_parameters, save_inscription } from "./services";
import { TextInput } from "./TextInput";

const defaultFormValues = { nom: null, prenom: null, email: null, telephone: null };

export default function Register() {
    const [loading, set_loading] = useState(true);
    const [success, set_success] = useState(false);
    const [inscriptions_enabled, set_inscriptions_enabled] = useState(true);

    useEffect(() => {
        async function check_inscriptions_enable() {
            try {
                const { data: parameters } = await get_parameters();
                const { data: inscriptions } = await get_inscriptions();
                if (parameters[0].stop_inscriptions || inscriptions?.length >= parameters[0].max_nb_inscriptions) {
                    console.log("not enabled");
                    set_inscriptions_enabled(false);
                }
                set_loading(false);
            } catch (e) {
                toast.error("Erreur dans la récupération des paramètres/inscriptions");
                console.log(e);
            }
        }

        check_inscriptions_enable();
    }, []);

    const { control, handleSubmit, reset } = useForm({
        defaultValues: defaultFormValues,
    });

    document.title = "S'inscrire";

    const onSubmit = async (values) => {
        set_loading(true);
        try {
            if (!values.nom || !values.prenom || !values.email) {
                toast.error("Une information est manquante !");
                set_loading(false);
                return;
            }
            const { data: inscriptions_with_same_email } = await get_inscriptions({ email: values.email });
            if (inscriptions_with_same_email?.length > 0) {
                toast.error("Cette adresse mail est déjà utilisée pour une inscription");
                set_loading(false);
                return;
            }

            const res = await save_inscription(values);
            if (res.status < 200 || res.status >= 400) {
                throw new Error("Wrong return code");
            }
            toast.success("Inscription enregistrée !");
            reset(defaultFormValues);
            set_success(true);
        } catch (e) {
            console.log(e);
            toast.error("Erreur dans l'enregistrement de l'inscription");
        }
        set_loading(false);
    };

    return (
        <Box sx={{ my: 5 }}>
            <Backdrop
                open={loading}
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {inscriptions_enabled ? (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} direction="column" alignItems="center" justify="center">
                        <Grid item xs={12} md={12}>
                            <TextInput required name="nom" fullWidth control={control} label="Nom" disabled={success} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextInput required name="prenom" fullWidth control={control} label="Prénom" disabled={success} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextInput required name="email" fullWidth control={control} label="Email" disabled={success} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextInput required name="telephone" fullWidth control={control} label="Téléphone" disabled={success} />
                        </Grid>
                        <Grid item xs={12} md={12} align="left">
                            {success && (
                                <Alert severity="success" sx={{ mt: 2 }}>
                                    <AlertTitle>Inscription enregistrée</AlertTitle>
                                    Ton inscription a bien été enregistrée !<br />
                                    <br /> Tu vas recevoir un mail (vérifie tes spams) avec un QR code qui sera à présenter le jour de l'événement,{" "}
                                    <br />
                                    ne l'oublie pas ainsi que ton beau costume et la participation demandée 😉
                                </Alert>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container spacing={5} paddingTop={5} direction="column" alignItems="center" justifyContent="center">
                        {success ? (
                            <Grid item xs={12}>
                                <a href="https://halloween-belle-grange.fr/">
                                    <Button variant="contained">Retourner au site</Button>
                                </a>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Button variant="contained" type="submit" endIcon={<SendAndArchiveOutlined />} loading={true}>
                                    S'inscrire
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </form>
            ) : (
                <Alert severity="warning" sx={{ mt: 2 }}>
                    <AlertTitle>Fin des inscriptions</AlertTitle>
                    Il n'est plus possible de s'inscrire pour le moment 😭
                </Alert>
            )}
        </Box>
    );
}
